/**
 * entities/notification/lib/payload — Type-narrowing helpers for Notification.payload.
 *
 * The generated schema types `payload` as `unknown` (it's a free-form JSON blob
 * whose shape varies by notification `type`). Several notification types
 * (documents uploaded/updated, lift-scoped alerts) include a `lift_ids: string[]`
 * field identifying which lift(s) the notification relates to. This helper
 * safely extracts that array without assuming its shape.
 *
 * FSD: entities may import from shared only — this file has no dependencies.
 */

interface PayloadWithLiftIds {
  lift_ids?: unknown;
}

/**
 * Safely extracts `lift_ids` from a notification's `payload`, returning an
 * empty array when the payload is not an object, has no `lift_ids` field, or
 * `lift_ids` is not an array of strings.
 */
export function getNotificationLiftIds(payload: unknown): string[] {
  if (typeof payload !== 'object' || payload === null) return [];
  const liftIds = (payload as PayloadWithLiftIds).lift_ids;
  if (!Array.isArray(liftIds)) return [];
  return liftIds.filter((id): id is string => typeof id === 'string');
}
